import { Card, CardContent, ColorSwatchPicker, Skeleton } from '@all-manager/design-system-v2';
import { EVENT_MATERIAL_COLORS } from './constants';
import { useEventColorConfig } from './useEventColorConfig';

type Props = {
  subTopicId: string;
};

export default function EventColorConfig(props: Props) {
  const hook = useEventColorConfig(props);

  return (
    <Card>
      <CardContent>
        {hook.isLoading ? (
          <Skeleton variant="rounded" height={88} aria-label="Chargement de la couleur" />
        ) : (
          <ColorSwatchPicker
            label="Couleur dans le planning"
            description="Les rendez-vous de ce sous-sujet prennent cette couleur dans le planning."
            options={EVENT_MATERIAL_COLORS}
            value={hook.selectedColor}
            onChange={hook.handleSelectColor}
            defaultOptionLabel="Couleur par défaut des rendez-vous"
            disabled={hook.isUpdating}
          />
        )}
      </CardContent>
    </Card>
  );
}
